import React, { useState, useEffect } from "react";
import "./index.scss";
import md5 from "js-md5";
import {
  create_phone,
  create_account,
  accountCheck,
  askAccount,
  login,
} from "../../api/create";
import { Input, Button, Modal, message, Layout, Checkbox } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { data } from "browserslist";

const Index = (props) => {
  const [conpassword_check, Setconpassword_check] = useState(false),
    [agreeLoading, SetagreeLoading] = useState(false), //按钮加载状态
    [password_check, Setpassword_check] = useState(false),
    [account_check, Setaccount_check] = useState(false),
    [checkboxmsg, Setcheckboxmsg] = useState(""),
    [passwordCheck, SetpasswordCheck] = useState(false),
    [conpasswordCheck, SetconpasswordCheck] = useState(false),
    [yzmMsg, SetyzmMsg] = useState(""),
    [yzmErrorFlag, SetyzmErrorFlag] = useState(false),
    [accountCheck, SetaccountCheck] = useState(false),
    [timeDown, SettimeDown] = useState(10),
    [createSuccess, SetcreateSuccess] = useState(false),
    [checkShow, SetcheckShow] = useState(false),
    [checkboxCheck, SetcheckboxCheck] = useState(false),
    [checkboxChecks, SetcheckboxChecks] = useState(true),
    [registration_agreement, Setregistration_agreement] = useState(false),
    [account, Setaccount] = useState(""),
    [password, Setpassword] = useState(""),
    [conPassword, SetconPassword] = useState(""),
    [phone_number, Setphone_number] = useState(""),
    [count_ture, Setcount_ture] = useState(false),
    [count, Setcount] = useState(undefined),
    [verifuNumber, SetverifyNumber] = useState(""),
    [accountInfoFlag, SetaccountInfoFlag] = useState(false),
    [accountErrorFlag, SetaccountErrorFlag] = useState(false),
    [accountMsg, SetaccountMsg] = useState(""),
    [accountSuccess, SetaccountSuccess] = useState(false),
    [passwordErrorFlag, SetpasswordErrorFlag] = useState(false),
    [passwordSuccess, SetpasswordSuccess] = useState(false),
    [passwordInfoFlag, SetpasswordInfoFlag] = useState(false),
    [passwordmsg, Setpasswordmsg] = useState(""),
    [conpasswordErrorFlag, SetconpasswordErrorFlag] = useState(false),
    [conPasswordmsg, SetconPasswordmsg] = useState(""),
    [conpasswordSuccess, SetconpasswordSuccess] = useState(""),
    [conPasswordInfoFlag, SetconPasswordInfoFlag] = useState(false),
    [phoneErrorFlag, SetphoneErrorFlag] = useState(false),
    [phoneMsg, SetphoneMsg] = useState("");
  let password_modification_timer;
  let timer;

  useEffect(() => {
    if (window.document.location.search?.split("email=")[1]?.split("&")[0]) {
      Setaccount(
        window.document.location.search.split("email=")[1].split("&")[0]
      );
    }
  }, []);
  function countDown() {
    let count = 10;
    timer = setInterval(() => {
      if (document.getElementById("createFinish") === null) {
        clearInterval(timer);
      } else {
        if (count > 0) {
          count = count - 1;
          SettimeDown(count);
        } else {
          clearInterval(timer);
          // window.location.href = "/login";
          getLogin();
        }
      }
    }, 1000);
  }
  useEffect(() => {
    if (!account_check && account !== undefined && account !== "") {
      accountBlur();
    }
  }, [account]);
  useEffect(() => {
    if (!password_check && password !== undefined && password !== "") {
      passwordBlur();
    }
  }, [password]);
  function accountFocus() {
    SetaccountErrorFlag(false);
    SetaccountInfoFlag(true);
    SetaccountSuccess(false);
    SetaccountCheck(false);
    Setaccount_check(true);
  }
  async function accountBlur() {
    SetaccountInfoFlag(false);
    // let reg =
    //   /^(?![0-9@._]+$)(?![a-zA-Z@._]+$)[0-9A-Za-z][0-9A-Za-z@._]{8,59}$/;
    if (
      !(
        /^[a-zA-Z0-9@._]{8,60}$/.test(account) &&
        !/^[1][3,4,5,6.7,8,9][0-9]{9}$/.test(account)
      )
    ) {
      SetaccountCheck(true);
      SetaccountSuccess(false);
      if (!account) {
        SetaccountMsg("账号未填写！");
      } else {
        SetaccountMsg("账号格式错误！");
      }
      SetaccountErrorFlag(true);
    } else {
      let data = {
        account,
      };
      let accountResult = await askAccount(data);
      if (accountResult.code === 200) {
        SetaccountSuccess(true);
        SetaccountCheck(false);
      } else {
        SetaccountMsg(accountResult.msg);
        SetaccountSuccess(false);
        SetaccountCheck(true);
        SetaccountErrorFlag(true);
      }
    }
  }

  function passwordFocus() {
    SetpasswordErrorFlag(false);
    SetpasswordInfoFlag(true);
    SetpasswordSuccess(false);
    SetconpasswordSuccess(false);
    SetpasswordCheck(false);
    Setpassword_check(true);
  }
  function passwordBlur() {
    SetpasswordInfoFlag(false);
    let reg =
      /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)(?![a-zA-Z]+$)\S{8,20}$/;
    if (!password.match(reg)) {
      SetpasswordSuccess(false);
      SetpasswordCheck(true);
      if (!password) {
        Setpasswordmsg("密码未填写！");
      } else {
        Setpasswordmsg("密码格式错误");
      }
      SetpasswordErrorFlag(true);
    } else {
      SetpasswordSuccess(true);
      if (conPassword === password) {
        SetconpasswordErrorFlag(false);
        SetconpasswordSuccess(true);
        SetconpasswordCheck(false);
      } else {
        if (conpassword_check) {
          SetconPasswordmsg("两次密码输入不匹配，请重新输入！");
          SetconpasswordCheck(true);
          SetconpasswordSuccess(false);
          SetconpasswordErrorFlag(true);
        }
      }
    }
  }

  function conpasswordFocus() {
    Setconpassword_check(true);
    SetconpasswordErrorFlag(false);
    SetconPasswordInfoFlag(true);
    // SetpasswordSuccess(false);
    SetconpasswordSuccess(false);
    SetconpasswordCheck(false);
  }
  function conpasswordBlur() {
    SetconPasswordInfoFlag(false);

    let reg =
      /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)(?![a-zA-Z]+$)\S{8,20}$/;
    if (!conPassword.match(reg)) {
      SetconpasswordSuccess(false);
      SetconpasswordCheck(true);
      if (!conPassword) {
        SetconPasswordmsg("确认密码未填写！");
      } else {
        SetconPasswordmsg("确认密码格式错误");
      }
      SetconpasswordErrorFlag(true);
    } else if (password !== conPassword) {
      SetconpasswordCheck(true);
      SetconpasswordSuccess(false);
      SetconPasswordmsg("两次密码输入不匹配，请重新输入！");
      SetconpasswordErrorFlag(true);
    } else {
      SetconpasswordCheck(false);
      SetconpasswordSuccess(true);
    }
  }

  function phoneFocus() {
    SetphoneErrorFlag(false);
    // SetphoneCheck(false);
  }
  function phoneBlur() {
    let reg = /^1[3456789]\d{9}$/;
    if (!phone_number.match(reg)) {
      if (!phone_number) {
        SetphoneMsg("手机号未填写！");
      } else {
        SetphoneMsg("手机号格式错误！");
      }
      SetphoneErrorFlag(true);
    }
  }
  //发送验证码
  function send_code() {
    if (phone_number === "" || phone_number === undefined) {
      message.error("请填写手机号");
    } else {
      // count_down();
      document.getElementById("createBtn").disabled = "disabled";
      // document.getElementById("createBtn").style.backgroundColor = "#f5f5f5";
      // count_down()
      getmessage();
    }
  }
  //验证码短信请求
  async function getmessage() {
    const datas = {
      type: "1",
      phone: phone_number,
    };
    let getVerification = await create_phone(datas);
    console.log(getVerification);
    if (getVerification.code === 201) {
      document.getElementById("createBtn").style.backgroundColor = "#f5f5f5";
      count_down();
    } else {
      document.getElementById("createBtn").disabled = "";
      message.error(getVerification.message);
      // Setphone_number("");
    }
  }
  //60秒倒计时
  function count_down() {
    var count = 60;
    // const old_time=sessionStorage.getItem('time')
    password_modification_timer = setInterval(() => {
      //  let time=new Date().getTime()-old_time
      if (count <= 0) {
        clearInterval(password_modification_timer);
        // sessionStorage.removeItem('time')
        Setcount(undefined);
        document.getElementById("createBtn").disabled = "";
        document.getElementById("createBtn").style.background = "#FFFFFF";
      } else {
        // document.getElementById("createBtn").background = "#F5F5F5";
        count = count - 1;
        Setcount(count);
        Setcount_ture(true);
      }
    }, 1000);
  }
  useEffect(() => {
    var reg =
      /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    if (phone_number.length === 11) {
      if (!reg.test(phone_number)) {
        document.getElementById("createBtn").disabled = "disabled";
      } else {
        document.getElementById("createBtn").disabled = "";
      }
    } else {
      if (document.getElementById("createBtn")) {
        document.getElementById("createBtn").disabled = "disabled";
      }
    }
  }, [phone_number]);
  //协议查看
  function registration_agreement_btn() {
    Setregistration_agreement(true);
  }
  //协议确认框
  function checkboxChange(e) {
    // console.log(e.target.checked);
    SetcheckboxCheck(e.target.checked);
  }
  //注册确认
  function agree() {
    if (phone_number === "" || phone_number === undefined) {
      SetphoneErrorFlag(true);
      SetphoneMsg("手机号码未填写");
    }
    if (verifuNumber === "" || verifuNumber === undefined) {
      SetyzmErrorFlag(true);
      SetyzmMsg("验证码未填写");
    }
    if (account === "" || account === undefined) {
      SetaccountCheck(true);
      SetaccountErrorFlag(true);
      SetaccountMsg("账号未填写");
    }
    if (password === "" || password === undefined) {
      SetpasswordCheck(true);
      SetpasswordErrorFlag(true);
      Setpasswordmsg("密码未填写");
    }
    if (conPassword === "" || conPassword === undefined) {
      SetconpasswordCheck(true);
      SetconpasswordErrorFlag(true);
      SetconPasswordmsg("确认密码未填写");
    }
    if (checkboxCheck === false) {
      SetcheckboxChecks(false);
      Setcheckboxmsg("请勾选同意用户注册协议");
    }
    if (
      accountCheck ||
      passwordCheck ||
      conpasswordCheck ||
      !checkboxCheck ||
      phoneErrorFlag ||
      yzmErrorFlag
    ) {
    } else {
      if (
        phone_number === "" ||
        verifuNumber === "" ||
        account === "" ||
        password === "" ||
        conPassword === ""
      ) {
      } else {
        pass();
      }
    }

    // if (checkboxCheck) {
    //   pass();
    // } else {
    //   SetcheckShow(true);
    // }
  }
  useEffect(() => {
    if (checkboxCheck) {
      Setcheckboxmsg("");
      SetcheckboxChecks(true);
    }
  }, [checkboxCheck]);
  async function pass() {
    SetagreeLoading(true);
    if (phone_number === "" || phone_number === undefined) {
      message.error("手机号不能为空");
    } else {
      if (verifuNumber === "" || verifuNumber === undefined) {
        message.error("验证码不能为空");
      } else {
        let datas = {
          type: "2",
          account: account,
          password: password,
          password1: conPassword,
          phone: phone_number,
          code: verifuNumber,
        };
        datas.password = md5(datas.password);
        datas.password1 = md5(datas.password1);
        let createAccount = await create_account(datas);
        if (createAccount.code === 201) {
          SetcreateSuccess(true);
          countDown();
          SetcheckShow(false);
        } else {
          message.error(createAccount.message);
        }
        SetagreeLoading(false);
      }
    }
  }
  async function getLogin() {
    let mdPassword = md5(password);
    let data = { account, password: mdPassword };
    let login_result = await login(data);
    if (login_result.code === 200) {
      window.location.href = login_result.data;
    } else {
      message.error(login_result.msg);
    }
  }
  function goLogin() {
    // window.location.href = "/login";
    getLogin();
    clearInterval(timer);
  }
  function verifuNumberFocus() {
    SetyzmErrorFlag(false);
    SetyzmMsg("");
  }
  function verifuNumberBlur() {
    if (verifuNumber === "" || verifuNumber === undefined) {
      SetyzmErrorFlag(true);
      SetyzmMsg("验证码未填写");
    }
  }
  return (
    <div className="createAccount">
      {createSuccess ? (
        <div className="createFinish" id="createFinish">
          <div className="createFinishTip">您已成功创建快服通行证</div>
          <div className="createFinishAccount">账号：{account}</div>
          <div className="createFinishPassword">手机：{phone_number}</div>
          <Button className="createFinishBtn" onClick={goLogin}>
            前往快服网体验产品({timeDown})
          </Button>
        </div>
      ) : (
        <div>
          <div className="createAccountHead">
            <p className="title">创建您的快服通行证</p>
            <p className="text">
              只需一个账户，您即可购买使用所有 快服 的产品和服务
            </p>
          </div>
          <div className="createAccountFormArea">
            <p>
              <Input
                placeholder="账号"
                // className="accountInout"
                className={`accountInout ${accountCheck ? "active" : ""}`}
                value={account}
                onChange={(e) => {
                  Setaccount(e.target.value);
                }}
                autocomplete="off"
                // onMouseLeave={() => {
                //   accountBlur();
                // }}
                // onMouseEnter={() => {
                //   accountFocus();
                // }}
                onFocus={accountFocus}
                onBlur={accountBlur}
              />
              {accountSuccess ? (
                <div className="inputSuccess">
                  <CheckCircleOutlined />
                </div>
              ) : (
                ""
              )}
            </p>
            <div className="accountInfo ">
              {accountInfoFlag ? (
                <span>
                  8-60位帐号，帐号为字母或数字，不能为手机号，可含有@._三种字符
                </span>
              ) : (
                ""
              )}
              {accountErrorFlag ? (
                <span style={{ color: "#FA8C16" }}>{accountMsg}</span>
              ) : (
                ""
              )}
            </div>
            <p>
              <Input.Password
                autocomplete="new-password"
                placeholder="密码"
                // className="accountInout"
                className={`accountInout ${passwordCheck ? "active" : ""}`}
                value={password}
                onChange={(e) => {
                  // let reg = /^[0-9A-Za-z@._]*$/;
                  let regs = new RegExp("[\\u4E00-\\u9FFF]+", "g");
                  // let reg = /^[\u4e00-\u9fa5]+$/;
                  let reg = new RegExp(/\s+/g);
                  if (e.target.value === "" || e.target.value === undefined) {
                    Setpassword(e.target.value);
                  } else {
                    if (!regs.test(e.target.value)) {
                      if (!reg.test(e.target.value)) {
                        Setpassword(e.target.value);
                      }
                    }
                  }

                  // Setpassword(e.target.value);
                }}
                // onMouseLeave={() => {
                //   passwordBlur();
                // }}
                // onMouseEnter={() => {
                //   passwordFocus();
                // }}
                onFocus={passwordFocus}
                onBlur={passwordBlur}
              />
              {passwordSuccess ? (
                <div className="inputSuccess">
                  <CheckCircleOutlined />
                </div>
              ) : (
                ""
              )}
            </p>
            <div className="accountInfo ">
              {passwordInfoFlag ? (
                <span>
                  密码长度为8-20位，不能为纯数字或字母，且不能含有空格和中文
                </span>
              ) : (
                ""
              )}
              {passwordErrorFlag ? (
                <span style={{ color: "#FA8C16" }}>{passwordmsg}</span>
              ) : (
                ""
              )}
            </div>
            <p>
              <Input.Password
                placeholder="密码确认"
                // className="accountInout"
                className={`accountInout ${conpasswordCheck ? "active" : ""}`}
                value={conPassword}
                onChange={(e) => {
                  // SetconPassword(e.target.value);
                  let reg = new RegExp(/\s+/g);
                  let regs = new RegExp("[\\u4E00-\\u9FFF]+", "g");
                  if (e.target.value === "" || e.target.value === undefined) {
                    SetconPassword(e.target.value);
                  } else {
                    if (!regs.test(e.target.value)) {
                      if (!reg.test(e.target.value)) {
                        SetconPassword(e.target.value);
                      }
                    }
                  }
                }}
                onFocus={conpasswordFocus}
                onBlur={conpasswordBlur}
              />
              {conpasswordSuccess ? (
                <div className="inputSuccess">
                  <CheckCircleOutlined />
                </div>
              ) : (
                ""
              )}
            </p>
            <div className="accountInfo ">
              {conPasswordInfoFlag ? (
                <span>
                  密码长度为8-20位，不能为纯数字或字母，且不能含有空格和中文
                </span>
              ) : (
                ""
              )}
              {conpasswordErrorFlag ? (
                <span style={{ color: "#FA8C16" }}>{conPasswordmsg}</span>
              ) : (
                ""
              )}
            </div>
            <p className="phoneArea">
              <p className="phoneInputArea">
                <Input
                  // className="PhoneInput"
                  className={`PhoneInput ${phoneErrorFlag ? "active" : ""}`}
                  placeholder="手机"
                  value={phone_number}
                  onChange={(e) => {
                    Setphone_number(e.target.value);
                    document.getElementById("createBtn").disabled = "disabled";
                  }}
                  onFocus={phoneFocus}
                  onBlur={phoneBlur}
                ></Input>
              </p>
              <Button className="sendVerify" id="createBtn" onClick={send_code}>
                {count
                  ? count + "s"
                  : count_ture === true
                  ? "重新发送"
                  : "发送验证码"}
              </Button>
            </p>
            <div className="accountInfo ">
              {phoneErrorFlag ? (
                <span style={{ color: "#FA8C16" }}>{phoneMsg}</span>
              ) : (
                ""
              )}
            </div>
            <p>
              <Input
                // className="vertifyInput"
                className={`vertifyInput ${yzmErrorFlag ? "active" : ""}`}
                placeholder="验证码"
                value={verifuNumber}
                onChange={(e) => {
                  SetverifyNumber(e.target.value);
                }}
                onFocus={verifuNumberFocus}
                onBlur={verifuNumberBlur}
              ></Input>
            </p>
            <div className="accountInfo ">
              {yzmErrorFlag ? (
                <span style={{ color: "#FA8C16" }}>{yzmMsg}</span>
              ) : (
                ""
              )}
            </div>
            <p className="readAgreement">
              <Checkbox
                // type="checkbox"
                name=""
                className="agreementChecked"
                onChange={checkboxChange}
                checked={checkboxCheck}
              />
              <p>
                我已阅读并接受
                <a href="javascript:;" onClick={registration_agreement_btn}>
                  《快服用户注册协议》
                </a>
              </p>
              <div className="accountInfos ">
                {!checkboxChecks ? (
                  <span style={{ color: "#FA8C16" }}>{checkboxmsg}</span>
                ) : (
                  ""
                )}
              </div>
            </p>
            <p className="RegisterButtonArea">
              <Button
                className="registerButton"
                block={true}
                onClick={agree}
                loading={agreeLoading}
              >
                同意条款并注册
              </Button>
            </p>
            <div className="goLogin">
              <p className="title">已有账户，</p>
              <p
                className="tip"
                onClick={() => {
                  props.history.push("/login");
                }}
              >
                立即登录
              </p>
            </div>
          </div>
        </div>
      )}

      <Modal
        width={640}
        footer={null}
        centered
        visible={registration_agreement}
        onCancel={() => Setregistration_agreement(false)}
        className="registration_agreement_modal"
      >
        <div className="registration_agreement_main">
          <div className="registration_agreement_title">
            53快服云软件平台服务条款
          </div>
          <div className="registration_agreement_body">
            <p className="big_title">
              一、本服务条款是用户（您）与金华快服科技有限公司（以下称快服）之间的协议。本网站由快服或其关联公司所运行的各个网站、网页和软件产品构成。
            </p>
            <p className="big_title">
              二、特别提醒
              用户（您）欲访问本站或使用快服产品前，必须事先认真阅读本服务条款中各条款，包括免除或者限制快服责任的条款及对用户的权利限制。如您不同意本服务条款及/或随时对其的修改，您应不使用或主动取消快服公司提供的服务。您的使用行为将被视为您对本服务条款全部的完全接受，包括接受快服对服务条款随时所做的任何修改。在开通产品的同时，您也同时承认了您拥有使用这些产品的权利能力和行为能力。
            </p>
            <p className="big_title">
              三、用户使用规则
              本站运用自己的操作系统通过国际互联网络为用户提供网络服务。同时，用户必须：
              <p>
                (1)自行配备上网的所需设备，包括个人电脑、调制解调器或其它必备上网装置；
              </p>
              <p>
                (2)自行负担个人上网所支付的与此服务有关的电话费用、网络费用。
              </p>
              基于本站所提供的网络服务的重要性，用户应同意：
              <p>
                (1)保证自己在使用各服务时用户身份的真实性及完整性，如果资料发生变化，您应及时更改；
              </p>
              <p>
                (2)在安全完成本服务的注册程序后，您应维持密码及帐号的机密安全。您应对任何人利用您的密码及帐号所进行的活动负完全的责任；
              </p>
              遵守国家的有关法律、法规和行政规章制度，用户同意严格遵守以下条款，包括但不限于下列内容：
              <p>
                (1)快服公司对其发行的或与合作公司共同发行的包括但不限于产品或服务的全部内容及网站上的材料拥有版权等知识产权，受法律保护；
              </p>
              <p>
                (2)未经本公司书面许可，任何单位及个人不得以任何方式或理由对快服公司产品、服务、信息、材料的任何部分进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。
              </p>
              <p>
                (3)凡侵犯本公司版权等知识产权的，本公司必依法追究其法律责任。
              </p>
              <p>
                (4)如用户违反国家法律法规或本服务条款，本公司和合作公司将有权停止向用户提供服务而不需承担任何责任，如导致快服或合作公司遭受任何损害或遭受任何来自第三方的纠纷、诉讼、索赔要求等，用户须向本公司或合作公司赔偿相应的损失，并对其违反服务条款所产生的一切后果负全部法律责任。
                依本服务条款所取得的服务权利不可转让。
              </p>
            </p>
            <p className="big_title">
              四、隐私权保护
              尊重用户个人隐私是本站的一项基本政策。本站不会在未经合法用户授权或服务条款约定情况下公开、编辑或透露保存在本站中的非公开信息。
              非公开内容是指用户帐号、密码、所在地区、公司电话、联系人及其职务和联系方式、电子邮箱等用户信息；
              用户同意并允许公示与快服的交易信息，且该交易信息仅以交易时间、公司名称及交易的具体产品为限。
            </p>
            <p className="big_title">
              五、服务条款变更、中断或终止
              本服务的所有权和运作权、解释权归快服公司。
              本公司有权在必要时修改服务条款，服务条款一旦发生变动，将会在相关页面上公布修改后的服务条款。如果不同意所改动的内容，用户应主动取消此项服务。如果用户继续使用服务，则视为接受服务条款的变动。
              快服和合作公司有权按需要修改或变更所提供的价格标准、收费方式及服务条款。快服在提供服务时，可能现在或日后对部分服务的用户开始收取一定的费用或改变收费方式，如用户拒绝支付该等费用则不能在收费开始后继续使用相关的服务。但快服和合作公司将尽最大努力通过电邮或其他有效方式通知用户有关的修改或变更。
              本公司特别提请用户注意，本公司为了保障公司业务发展和调整的自主权，本公司拥有经或未经事先通知而修改服务内容、中断或中止部分或全部服务的权利，修改会公布于网站相关页面上，一经公布视为通知。快服公司行使修改或中断服务的权利而造成损失的，快服公司不需对免费用户或其关联任何第三方负责。
              如发生下列任何一种情形，本公司有权随时中断或终止向用户提供服务而无需通知用户：
              <p> (1)用户提供的个人资料不真实；</p>
              <p> (2)用户违反本服务条款的规定；</p>
              <p>(3)按照主管部门的要求；</p>
              <p>(4)其他本公司认为是符合整体服务需求的特殊情形。</p>
            </p>
            <p className="big_title">
              六、服务风险及免责声明
              用户须明白，本服务涉及到互联网及移动通讯等服务，可能会受到各个环节不稳定因素的影响。因此服务存在因上述不可抗力、计算机病毒或黑客攻击、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。开通服务的用户须承担以上风险，对因此导致用户不能发送和接受消息或传递错误、未予储存或其他问题不承担任何责任。
              如本公司的系统发生故障影响到本服务的正常运行，本公司承诺在第一时间内与相关单位配合，及时处理进行修复。
              快服在此郑重提请您注意，任何经由本公司产品或平台以上载、张贴、发送信息、电子邮件或任何其他方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息、用户的登记资料或其他资料（以下简称“内容”），无论系公开还是私下传送，均由内容提供者承担责任。快服公司无法控制经由本服务传送之内容，也无法对用户的使用行为进行全面控制，因此不保证内容的合法性、正确性、完整性、真实性或品质；但在任何情况下，快服公司有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本服务的全部或部分，保存有关记录，并向有关机关报告。
              如因不可抗力或其它本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等本站会尽可能合理地协助处理善后事宜，并尽最大努力使客户免受损失。
            </p>
            <p className="big_title">
              七、其他
              本公司的住所地为金华市婺城区，如果用户与本公司发生争议，用户同意将争议提交至本公司住所地有管辖权的人民法院通过诉讼的方式解决。
              如本服务条款中的任何条款无论因何种原因完全或部分无效或不具有执行力，本服务条款的其余条款仍应有效且具有约束力，并且努力使该规定反映之意向具备效力。
              每项服务及产品的内容、价格标准、收费方式应以最后发布的通知为准。
              用户对服务之任何部分或本服务条款的任何部分之意见及建议可通过本站主页在线客服与快服联系。
            </p>
            <p className="big_title">
              八、重要提示
              乙方不接受含木马、病毒、色情、赌博、诈骗、违禁用品、假冒产品、虚假信息等内容的网站注册申请，一经发现，乙方有权立即停止服务，对其业务造成影响乙方概不负责。
              经查实，甲方如为攻击对象网站，乙方有权将其拉入黑名单并禁用53KF软件，同时保留追究法律责任和经济损失的权力。
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Index;
